import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import type { ShiftResponsibility } from '../../shiftResponsibility/shiftResponsibilityTypes'
import css from '../incentiveProduct/incentiveProductDialog.css'
import ShiftResponsibilityForm from './ShiftResponsibilityForm'
type Props = {
  data: ShiftResponsibility | null | undefined
  isOpen: boolean
  stationId?: string
  onClose: (...args: Array<any>) => any
}

class ShiftResponsibilityDialog extends React.PureComponent<Props> {
  render() {
    const { data, stationId, isOpen, onClose } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.shiftResponsibilities.title.editDialog')
            : i18n.t('admin.shiftResponsibilities.title.createDialog')}
        </DialogTitle>
        <DialogContent>
          <ShiftResponsibilityForm data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default ShiftResponsibilityDialog
